"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatbotSettings = void 0;
var ChatBotMode = /*#__PURE__*/function (ChatBotMode) {
  ChatBotMode[ChatBotMode["Disabled"] = 0] = "Disabled";
  ChatBotMode[ChatBotMode["AlwaysEnabled"] = 1] = "AlwaysEnabled";
  ChatBotMode[ChatBotMode["NonBusinessHoursOnly"] = 2] = "NonBusinessHoursOnly";
  return ChatBotMode;
}(ChatBotMode || {});
/**
 * Returns settings for Chatbot.
 *
 * @returns {ChatboxSettings} - Settings applicable to Chatbot SPA.
 */
const getChatbotSettings = ({
  currentLanguage,
  customerId,
  data,
  environment,
  localizations,
  tenant,
  chatApiUrl,
  identityApiUrl
}) => ({
  data: {
    ConsultantNumber: data.customer?.consultantNumber ?? null,
    ContactSupportURL: data.chat?.chatBot?.configuration?.contactSupportUrl ?? '',
    CurrentLanguage: currentLanguage,
    CurrentTenant: tenant.toLowerCase(),
    CustomerFirstName: data.customer?.firstName ?? null,
    CustomerId: customerId,
    CustomerLastName: data.customer?.lastName ?? null,
    DirectLineChannelSecret: data.chat?.chatBot?.configuration?.directLineChannelSecret ?? '',
    Environment: environment,
    GlobalApiUrl: chatApiUrl,
    IdentityServerUrl: identityApiUrl,
    IsChatHandover: data.chat?.chatBot?.configuration?.isChatHandover ?? false,
    IsTestModeActive: data.chat?.chatBot?.configuration?.isTestModeActive ?? false,
    Localization: localizations,
    MessageHistoryLimit: data.chat?.chatBot?.configuration?.messageHistoryLimit ?? 10,
    Mode: typeof data.chat?.chatBot?.configuration?.mode === 'string' ? ChatBotMode[data.chat.chatBot.configuration.mode] : typeof data.chat?.chatBot?.configuration?.mode === 'number' ? data.chat.chatBot.configuration.mode : ChatBotMode.AlwaysEnabled
  }
});
exports.getChatbotSettings = getChatbotSettings;
